import * as React from 'react';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { InsightType } from 'utils/entities';
import MapIcon from 'assets/svg/map-1-5.svg';

interface SeeOnMapButtonProps {
  type: InsightType;
  onClick: () => void;
}

const ViewMapButton = styled.div<{type: InsightType}>`
  cursor: pointer;
  display: flex;
  justify-content: center;
  line-height: 24px;
  align-items: center;
  padding: 16px 0 8px;
  color: ${({ theme, type }) => theme.colors.insights[type]};
  fill: ${({ theme, type }) => theme.colors.insights[type]};
  svg {
    margin: 0 8px;
    color: inherit;
    path {fill: inherit;}
  }
`;

const ViewMapTopBorder = styled.div`
  position: absolute;
  display: block;
  height: 1px;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.colors.neutrals.grey8};
`;

export const SeeOnMapButton: React.FC<SeeOnMapButtonProps> = ({ type, onClick }) => {
  const { t } = useLocale();
  return (
    <div onClick={onClick}>
      <ViewMapTopBorder />
      <ViewMapButton data-auto="view-map-button" type={type}>
        <MapIcon />
        {t('insightsMobileMap.seeOnMapButton')}
      </ViewMapButton>
    </div>
  );
};
